import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/Api.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Patterns } from '../../../../../system/src/app/helpers/patterns';

@Component({
  selector: 'app-contact',
  standalone: false,
  templateUrl: './contact.component.html'
})
export class ContactComponent {
  loading = false;
  isActive = false;
  formGroup!: FormGroup;
  formSubmitted = false;
  // emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  // emailPattern = '[a-zA-Z0-9._]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}';
  faq: any = [
    {
      title: 'contact.q1title',
      answer: 'contact.q1answer'
    },
    {
      title: 'contact.q2title',
      answer: 'contact.q2answer'
    },
    {
      title: 'contact.q3title',
      answer: 'contact.q3answer'
    },
    {
      title: 'contact.q4title',
      answer: 'contact.q4answer'
    },
    {
      title: 'contact.q5title',
      answer: 'contact.q5answer'
    },
    {
      title: 'contact.q6title',
      answer: 'contact.q6answer'
    },
  ]

  constructor(
    private apiService: ApiService,
    private translate: TranslateService,
  ) {
    this.formGroup = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required,
        Validators.email,
        Validators.pattern(Patterns.email),]),
      message: new FormControl(null, [Validators.required
      ]),
    });
    this.isActive = true;
  }

  isInvalid(controlName: string): boolean {
    const control = this.formGroup.get(controlName);
    return control ? (control.invalid && (control.touched || this.formSubmitted)) : false;
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName) && this.isInvalid(controlName);
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      this.apiService.contactUs(this.formGroup.value).subscribe((res: any) => {
        this.loading = false;
        if (res.status) {
          this.formGroup.reset();
          this.formSubmitted = false;
          Swal.fire({
            title: this.translate.instant('general.success'),
            text: this.translate.instant('contact.success'),
            icon: 'success',
            confirmButtonText: this.translate.instant('general.ok'),
          });
        }
      }, (err: any) => {
        this.loading = false;
        console.log(err);
      });
    }
  }
}
